import { render } from "./PaddleComponent.vue?vue&type=template&id=7afa02ee&scoped=true&ts=true"
import script from "./PaddleComponent.vue?vue&type=script&lang=ts"
export * from "./PaddleComponent.vue?vue&type=script&lang=ts"

import "./PaddleComponent.vue?vue&type=style&index=0&id=7afa02ee&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afa02ee"]])

export default __exports__